const LOGO_GREEN = `${process.env.PUBLIC_URL}/assets/brand/cyrqle_color.png`;
const LOGO_WHITE = `${process.env.PUBLIC_URL}/assets/brand/cyrqle_white.png`;

export default function Logo({ variant = "green", className = "" }) {
  const src = variant === "white" ? LOGO_WHITE : LOGO_GREEN;
  return (
    <img
      src={src}
      alt="Cyrqle"
      className={`h-10 w-auto object-contain ${className}`}
      data-testid="sentinel-logo"
    />
  );
}
